<template>
  <div></div>
</template>

<script>
export default {
  name: 'ztLoginMobileSuccess'
}
</script>

<style scoped lang="scss"></style>
